var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3192 24.6289L8.99519 14.9619L17.0652 0.628906H21.9982L13.9292 14.9619L19.1992 24.6289H14.3192ZM7.02819 5.62891H2.08919L4.85719 10.3729L0.742188 17.6289H5.65619L9.77319 10.3579L7.02819 5.62891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXing);
export default __webpack_public_path__ + "static/media/Xing.6f7adb8d47f707e0033066f1729cb1f5.svg";
export { ForwardRef as ReactComponent };